import { object } from 'prop-types';
import React from 'react';
import { Link } from 'sly/system';

const NavPaths = ({ paths }) => {
  return (
    <>
      {paths.map((path, index) => {
        const content = [];
        const divider = <> / </>;
        if (path.to) {
          content.push(
            <Link
              className='font-b-s'
              to={path.link}
              data-tp-id='gen-Link-b117bc93-9d24-4ef3-a2e9-c7dafd248ccc'
            >
              {path.name}
            </Link>
          );
        } else {
          content.push(
            <span
              className='font-b-s'
              data-tp-id='gen-span-3f724b0c-1226-4791-8af6-b26cf1bf1a99'
            >
              {path.name}
            </span>
          );
        }
        if (index < paths.length - 1) {
          content.push(divider);
        }
        return content;
      })}
    </>
  );
};

NavPaths.propTypes = {
  paths: object,
};

export default NavPaths;
